import isSameCompany from "@Route/features/company/functions/isSameCompany";
import generateRoutePassengerGroups from "@Route/functions/generateRoutePassengerGroups";
import filterActivePassengerGroups from "@Route/functions/filterActivePassengerGroups";
import generateRouteTotalPrice from "@Route/functions/generateRouteTotalPrice";
import useSingleSelectedRoute from "@Route/hooks/useSingleSelectedRoute";
import usePassengers from "@Hooks/selector/usePassengers";
import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";
import PassengerGroupType from "@SearchResults/types/passenger/PassengerGroup.type";
import CurrencyType from "@Currency/types/Currency.type";
import RouteWithAddedPropsType from "@Route/types/RouteWithAddedProps.type";
import useSingleConfirmedRoute from "@Route/hooks/useSingleConfirmedRoute";

export default function useRoutePriceGenerator(passengerGroups: Record<string, PassengerGroupType>, currency: CurrencyType) {
    const {companyId: confirmedCompanyId, id: singleConfirmedRouteId} = useSingleConfirmedRoute() || {}
    const passengers = usePassengers()

    const generatePrices = (route: RouteWithAddedPropsType): RouteWithAddedPropsAndPricesType => {
        const {companyId, type, id: routeId} = route
        const sameCompany = isSameCompany({
            selectedSingleRouteCompanyId: confirmedCompanyId,
            routeCompanyId: companyId,
            isReturn: route?.status?.isReturn,
            singleConfirmedRouteId,
            routeId,
        })
        const routePassengerGroups = generateRoutePassengerGroups({
            route,
            // @ts-ignore
            activeCurrencyRate: currency.ratio,
            passengerGroups,
            sameCompany,
        })

        const activeGroups = filterActivePassengerGroups({
            route,
            passengers,
            passengerGroups: routePassengerGroups,
        })

        const {totalPrice, pricesPerGroup} = generateRouteTotalPrice(activeGroups, type.isPrivate)

        return {
            ...route,
            prices: {
                ...route.prices,
                price: totalPrice,
                pricesPerGroup,
            },
        }
    }

    return {
        generatePrices,
    }
}